import type { DashboardSummaryInput } from '@repo/api-contracts';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

/**
 * 어드민 대시보드 요약(dashboard.summary) — 처리 대기·기간 현황·미처리 상담·주의 필요 주문·인기 상품을 한 번에 읽는다.
 * 기간을 바꾸는 동안 이전 값을 자리표시자로 유지해 숫자가 깜빡이지 않게 한다. 서버가 조회 전에 관리자 접속기록(PII_ACCESSED)을 남긴다.
 */
export const useDashboardSummaryQuery = (input: DashboardSummaryInput) =>
  trpc.dashboard.summary.useQuery(input, { placeholderData: keepPreviousData });
